import React from 'react';
import { Redirect } from 'react-router-dom';
// src
import Login from './Authentication/Login.js';
import * as routes from '../routes/routes_production.js';

const Landing = ({ auth }) => ( 
  <div>
  	{auth() !== null
  		?	<Redirect to={routes.HOME} /> 
  		: <Login auth={auth} />
   	}
  </div>
);

export default Landing;


// WEBPACK FOOTER //
// ./src/cmp/Landing.js